import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  listing: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'listing' }),
  listingInquiry: generateApiPath({
    prefix: AuthLevel.ADMIN,
    name: 'listing-inquiry',
    plural: 'listing-inquiries',
  }),
}

export { paths }
